<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Filler Articles</h1>
        </div>
        <el-button
            @click="addArticle()"
            icon="mdi mdi-plus"
            round
            size="small"
            type="primary"
            v-if="can(Permissions.UPDATE_FILLER_ARTICLES)"
        >
            Add Filler Article
        </el-button>
        <div class="legend mt-20">
            <span v-for="(col, i) in columns">
                <b>{{ col.legend }}</b> = {{ col.name
                }}<span v-if="i < columns.length - 1">, </span>
            </span>
        </div>
        <table class="w-full mt-10 table-filler-article-availability">
            <thead>
                <tr>
                    <th>Headline</th>
                    <th>Body</th>
                    <th
                        class="text-center"
                        v-for="(col, i) in columns"
                        :key="i"
                    >
                        {{ col.legend }}
                    </th>
                    <th
                        class="text-center"
                        v-if="can(Permissions.UPDATE_FILLER_ARTICLES)"
                    >
                        Edit
                    </th>
                    <th
                        class="text-center"
                        v-if="can(Permissions.DELETE_FILLER_ARTICLES)"
                    >
                        Delete
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in tableData">
                    <td style="min-width: 200px">
                        {{ row.article.headline }}
                    </td>
                    <td>
                        {{ row.article.body_text | truncate(80) }}
                    </td>
                    <td class="text-center" v-for="col in row.columns">
                        <a
                            @click.prevent="
                                toggleAvailability(row.article, col.column)
                            "
                            href="#"
                            v-if="can(Permissions.UPDATE_FILLER_ARTICLES)"
                        >
                            <i
                                class="mdi availability-checkbox"
                                :class="{
                                    'mdi-checkbox-marked-circle': col.available,
                                    'mdi-checkbox-marked-circle-outline':
                                        !col.available,
                                    available: col.available,
                                }"
                            />
                        </a>
                        <i
                            :class="{
                                'mdi-checkbox-marked-circle': col.available,
                                'mdi-checkbox-marked-circle-outline':
                                    !col.available,
                                available: col.available,
                            }"
                            class="mdi availability-checkbox"
                            v-else
                        />
                    </td>
                    <td
                        class="text-center"
                        v-if="can(Permissions.UPDATE_FILLER_ARTICLES)"
                    >
                        <el-button
                            @click="editArticle(row.article)"
                            circle
                            icon="mdi mdi-pencil"
                            size="mini"
                        />
                    </td>
                    <td
                        class="text-center"
                        v-if="can(Permissions.DELETE_FILLER_ARTICLES)"
                    >
                        <el-button
                            icon="mdi mdi-delete"
                            type="danger"
                            circle
                            size="mini"
                            :loading="isItemBusy(row.article, 'delete')"
                            @click="deleteArticle(row.article)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as BusEvents from "@/constants/bus-events";
import * as Routes from "@/constants/routes";
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    beforeRouteEnter(to, from, next) {
        axios
            .get(`/web-api/filler-article`, {
                params: {
                    include: "availabilities",
                },
            })
            .then((response) => {
                next((vm) => vm.setData(response));
            });
    },
    data() {
        return {
            form: new Form({
                filler_articles: [],
            }),
            activeTab: "tab-0",
            editor: null,
            filler_articles: [],
            treeDefaultProps: {
                label: "name",
            },
            treeNodes: [],
            allTreeNodes: [],
            columns: [],
            loadingItems: [],
        };
    },
    mounted() {},
    computed: {
        ...mapState({
            corporations: (state) => state.corporations.data,
            communities: (state) => state.communities.data,
        }),
        ...mapState(["preset_data_fetched"]),
        activeTabIndex() {
            return parseInt(this.activeTab.split("-")[1]);
        },
        activeArticle() {
            return this.form.filler_articles[this.activeTabIndex];
        },
        tableData() {
            return _.map(this.filler_articles, (article) => {
                let columns = _.map(this.columns, (column) => {
                    let available = false;
                    let availability = _.find(
                        article.availabilities.data,
                        _.pick(column, ["model_id", "model_type"]),
                    );
                    if (availability) {
                        available = availability.available;
                    }
                    return {
                        column,
                        available,
                    };
                });
                return {
                    article,
                    columns,
                };
            });
        },
    },
    methods: {
        setData(response) {
            this.filler_articles = response.data.data;
            if (this.preset_data_fetched) {
                this.initColumns();
            } else {
                window.Bus.$once(BusEvents.PRESET_DATA_FETCHED, () => {
                    this.initColumns();
                });
            }
        },
        initColumns() {
            this.columns = [
                {
                    legend: "I",
                    name: "Independent",
                    model_type: "App\\Community",
                    model_id: null,
                },
            ];
            this.corporations.forEach((corp) => {
                if (corp.filler_visibility) {
                    this.columns.push({
                        legend: corp.abbr,
                        name: corp.name,
                        model_type: "App\\Corporation",
                        model_id: corp.id,
                    });
                }
            });
        },
        addArticle() {
            this.$router.push({
                name: Routes.CREATE_FILLER_ARTICLE,
            });
        },
        editArticle(article) {
            this.$router.push({
                name: Routes.EDIT_FILLER_ARTICLE,
                params: {
                    id: article.id,
                },
            });
        },
        deleteArticle(article) {
            this.$confirm(
                `Are you sure you want to delete filler article ${article.headline}?`,
                "Confirmation",
                {
                    confirmButtonText: "Delete Article",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning",
                },
            )
                .then(() => {
                    this.addBusyItem(article, "delete");
                    axios
                        .delete(`/web-api/filler-article/${article.id}`)
                        .then(() => {
                            Utils.arrayDelete(this.filler_articles, article);
                            this.$notify.success({
                                title: "Success",
                                message: `Filler article ${article.headline} has been deleted.`,
                            });
                        })
                        .finally(() => this.removeBusyItem(article, "delete"));
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        toggleAvailability(filler_article, column) {
            let availability = _.find(
                filler_article.availabilities.data,
                _.pick(column, ["model_type", "model_id"]),
            );
            axios
                .put(
                    `/web-api/filler-article/${filler_article.id}/availability`,
                    {
                        ..._.pick(column, ["model_type", "model_id"]),
                        available: availability
                            ? !availability.available
                            : true,
                    },
                )
                .then((response) => {
                    if (availability) {
                        _.extend(availability, response.data);
                    } else {
                        filler_article.availabilities.data.push(response.data);
                    }
                });
        },
    },
};
</script>

<style scoped></style>
